(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Nibara"] = factory();
	else
		root["Nibara"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _package = __webpack_require__(33);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _VocLogger = __webpack_require__(15);
	
	var _VocLogger2 = _interopRequireDefault(_VocLogger);
	
	var _ModuleLoader = __webpack_require__(34);
	
	var _ModuleLoader2 = _interopRequireDefault(_ModuleLoader);
	
	var _ScriptLoader = __webpack_require__(35);
	
	var _ScriptLoader2 = _interopRequireDefault(_ScriptLoader);
	
	__webpack_require__(16);
	
	var _feature = __webpack_require__(21);
	
	var _feature2 = _interopRequireDefault(_feature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Voonto.ready.then(function (app) {
	
	  var vocLogger = new _VocLogger2.default(app),
	      moduleLoader = new _ModuleLoader2.default(app),
	      scriptLoader = new _ScriptLoader2.default(app),
	      Nibara = window.nibara;
	  //Nibara.nTools.addNibaraMethod('VERSION',pkg.version);
	  Nibara.VERSION = _package2.default.version;
	  Nibara.feature = (0, _feature2.default)();
	
	  vocLogger.initialize();
	  app.when('nibara:logger').then(function (Logger) {
	    Logger.debug('[Logger] nibara version: ' + _package2.default.version);
	    Nibara.logger = Logger;
	    moduleLoader.initialize();
	    scriptLoader.initialize();
	
	    Logger.debug('[Logger] Fin initialize ModuleLoader y ScriptLoader');
	
	    Nibara.moduleLoaderUpdate = function ($elm) {
	      if ($elm instanceof jQuery) {
	        moduleLoader.initialize($elm);
	      } else {
	        Logger.warn('[Logger] Can not initialize moduleLoader. Element is not instance of jQuery.');
	      }
	    };
	  });
	
	  /*vocLogger.initialize().then(() => {
	    Logger.debug('nibara version: ' + pkg.version);
	     moduleLoader.initialize();
	    scriptLoader.initialize();
	     Nibara.moduleLoaderUpdate = ($elm) => {
	      if($elm instanceof jQuery) {
	        moduleLoader.initialize($elm);
	      } else {
	        Logger.warn('Can not initialize moduleLoader. Element is not instance of jQuery.');
	      }
	    };
	  }).catch((e) => {
	    Logger.error('Main exception:' + e.message);
	  });*/
	});

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var VocLogger = function () {
	    function VocLogger(app) {
	        _classCallCheck(this, VocLogger);
	
	        this.app = app;
	        this.path = app.lookup('vocento.config.nibara').path;
	        if (this.path === undefined) {
	            throw 'nibara path config is empty';
	        }
	        this.libPath = app.lookup('vocento.config.nibara').libPath;
	        if (this.libPath === undefined) {
	            throw 'nibara libPath config is empty';
	        }
	    }
	
	    _createClass(VocLogger, [{
	        key: 'initialize',
	        value: function initialize() {
	            var _this = this;
	
	            if (nibara.nTools.getUrlParam('nibara_debug') === '1') {
	                this.app.require([this.path + '/logger.min.js'], function (Logger) {
	                    /** logger init **/
	                    Logger.useDefaults();
	                    var myHandler = Logger.createDefaultHandler({
	                        formatter: function formatter(messages) {
	                            messages.unshift('nibara_debug::');
	                        }
	                    });
	                    Logger.setHandler(function (messages, context) {
	                        myHandler(messages, context);
	                    });
	
	                    /** Change level with require_debug param */
	                    Logger.setLevel(Logger.WARN);
	                    if (nibara.nTools.getUrlParam('nibara_debug') === '1') {
	                        Logger.setLevel(Logger.DEBUG);
	                    }
	
	                    Logger.debug('Loggger initialized');
	                    _this.app.promised('nibara:logger', Logger);
	                });
	            } else {
	                var debug = function debug() {
	                    /*console.log('[NO-LOGGER]');
	                    console.log.apply(console, arguments);*/
	                };
	
	                var Logger = {
	                    debug: debug,
	                    info: debug,
	                    warn: debug,
	                    error: debug
	                };
	
	                this.app.promised('nibara:logger', Logger);
	            }
	        }
	    }]);
	
	    return VocLogger;
	}();
	
	exports.default = VocLogger;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _normalizer = __webpack_require__(17);
	
	var _normalizer2 = _interopRequireDefault(_normalizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NibaraInstance = function (window) {
	  var app = Voonto.getInstance();
	
	  var nTools = {};
	  var nodes = {
	    0: "static",
	    1: "static1",
	    2: "static2",
	    3: "static3",
	    4: "static4"
	  };
	
	  nTools.getStaticNode = function (url) {
	    if (window.location.href.match('docker|des-') !== null) {
	      return url;
	    }
	    var mod = url.length % 5;
	    if (url.match('static.abc.es')) {
	      url = url.replace('static', nodes[mod]);
	      //Logger.debug('static host modified: ' + url);
	    }
	    return url;
	  };
	
	  nTools.cleanerUrl = function (url) {
	    var marks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    if (marks) {
	      //clean marcas de tags o tracking
	      url = url.replace(/#\w.*/g, '');
	    }
	    if (parameters) {
	      url = url.replace(/\?.*/g, '');
	    }
	    return url;
	  };
	
	  nTools.getUrlParams = function () {
	
	    var params = {};
	    var queryParams = window.location.search.length > 0 ? window.location.search.substr(1).split('&') : '';
	    var queryHash = window.location.hash.length > 0 ? window.location.hash.substr(1).split('&') : '';
	
	    var queryVars = {};
	    for (var i = 0; i < queryParams.length; i++) {
	      var hash = queryParams[i].split('=');
	
	      if (hash.length > 1) {
	        queryVars[hash[0]] = hash[1];
	      } else {
	        queryVars[hash[0]] = null;
	      }
	    }
	    params.queryParams = queryVars;
	
	    var hashVars = {};
	    for (var _i = 0; _i < queryHash.length; _i++) {
	      var _hash = queryHash[_i].split('=');
	
	      if (_hash.length > 1) {
	        hashVars[_hash[0]] = _hash[1];
	      } else {
	        hashVars[_hash[0]] = null;
	      }
	    }
	    params.queryHash = hashVars;
	
	    return params;
	  };
	
	  nTools.getUrlParam = function getUrlParam(name) {
	    var i = void 0,
	        hash = void 0,
	        hashes = void 0;
	    hashes = window.location.search.slice(1).split('&');
	    for (i = 0; i < hashes.length; i++) {
	      hash = hashes[i].split('=');
	      if (hash[0] === name) {
	        return hash.length > 1 ? hash[1] : '';
	      }
	    }
	    hashes = window.location.hash.slice(1).split('&');
	    for (i = 0; i < hashes.length; i++) {
	      hash = hashes[i].split('=');
	      if (hash[0] === name) {
	        return hash.length > 1 ? hash[1] : '';
	      }
	    }
	
	    return null;
	  };
	
	  /**
	   * Return boolean if nested item exists
	   * Use: (obj, 'level1', 'level2', ... 'levelN')
	   * @param obj
	   * @return {boolean}
	   */
	  nTools.isset = function (obj /*, level1, level2, ... levelN*/) {
	    var args = Array.prototype.slice.call(arguments, 1);
	
	    for (var i = 0; i < args.length; i++) {
	      if (!obj || !obj.hasOwnProperty(args[i])) {
	        return false;
	      }
	      obj = obj[args[i]];
	    }
	    return true;
	  };
	
	  /**
	   * KebabCase string
	   * @param str
	   * @return {string | *}
	   */
	  nTools.kebabCase2 = function (str) {
	    var result = void 0;
	
	    // Convierte mayus. camelCase a kebab-case.
	    result = str.replace(/([a-z][A-Z])/g, function (match) {
	      return match.substr(0, 1) + '-' + match.substr(1, 1);
	    });
	
	    result = result.toLowerCase();
	
	    /* Convierte no caracteres alfanumericos en '+' */
	    result = result.replace(/[^-a-z0-9áéíóúàèìòùüÜñÑ]{1}/g, '+');
	
	    return result;
	  };
	
	  /* Returns a function, that, when invoked, will only be triggered at most once
	   * during a given window of time. Normally, the throttled function will run
	   * as much as it can, without ever going more than once per `wait` duration */
	  nTools.throttle = function (wait, func) {
	    var timeout = void 0,
	        context = void 0,
	        args = void 0,
	        result = void 0;
	    var previous = 0;
	
	    var later = function later() {
	      previous = Date.now();
	      timeout = null;
	      result = func.apply(context, args);
	      context = args = null;
	    };
	
	    var throttled = function throttled() {
	      var now = Date.now();
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        context = args = null;
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	
	    return throttled;
	  };
	
	  nTools.createCookieByName = function (name, content, expTime) {
	    var expires = new Date();
	    expires.setTime(expires.getTime() + parseInt(expTime));
	    var cookie = name + "=" + content + ";expires=" + expires.toUTCString() + ";path=/";
	    //Logger.debug("[" + name + " creada]");
	    return document.cookie = cookie;
	  };
	
	  nTools.removeCookieByName = function (name, content, expTime) {
	    var expires = new Date();
	    expires.setTime(expires.getTime() - parseInt(expTime));
	    var cookie = name + "=" + content + ";expires=" + expires.toUTCString() + ";path=/";
	    //Logger.debug("[" + name + " eliminada]");
	    return document.cookie = cookie;
	  };
	
	  nTools.getContentCookie = function (name) {
	    var value = "; " + document.cookie;
	    var parts = value.split("; " + name + "=");
	    if (parts.length >= 2) {
	      return parts.pop().split(";").shift();
	    } else {
	      return '';
	    }
	  };
	
	  /**
	   * Obtienen la Seccion de la Variable de Comscore
	   * @returns {*}
	   */
	  nTools.getSectionComscore = function () {
	    return window.vocento.tracking.comscore.voc_se;
	  };
	  /**
	   * obtiene la Seccion a partir de la Url
	   * @returns {*|string}
	   */
	  nTools.getSectionUrl = function () {
	    var url = nTools.parseUrl(nTools.cleanerUrl(window.location.href));
	    var pathName = url.pathname;
	    var section = '';
	    if (pathName == '' || pathName == '/') {
	      section = "home";
	    } else {
	      section = pathName.split("/")[1];
	    }
	
	    return section;
	  };
	
	  /**
	   * Retorna un Objecto de Tipo Url Parse, con los datos de la url del parametro
	   * @param url
	   * @returns {{protocol: *, host: *, hostname: *, port: *, pathname: *, hash: *, search: *, origin: *}}
	   */
	  nTools.parseUrl = function (url) {
	    var parser = document.createElement('a');
	    parser.href = url;
	    return {
	      protocol: parser.protocol,
	      host: parser.host,
	      hostname: parser.hostname,
	      port: parser.port,
	      pathname: parser.pathname,
	      hash: parser.hash,
	      search: parser.search,
	      origin: parser.origin
	    };
	  };
	  /**
	   * Verifica si Existe la Cookie de Gigya del Login.
	   * @returns {void|RegExpMatchArray|*}
	   */
	  nTools.isLoginCookie = function () {
	    return window.document.cookie.match(/^(.*;)?\s*voc_uid\s*=\s*[^;]+(.*)?$/);
	  };
	
	  /**
	   *  Verifica siExiste el Objeto de Gigya y si esta Cargado vocUser Este método es un poco mas lento
	   *  que el usuado por la Cookie, pero Utiliza La Instancia de Gigya
	   * @returns {PromiseLike<boolean | never> | Promise<boolean | never> | *}
	   */
	  nTools.isLoginGigya = function () {
	    return app.when('vocuser:ready').then(function (gigyaUX) {
	      return typeof gigyaUX !== 'undefined' && gigyaUX.getUserType() !== 'anonimo';
	    });
	  };
	
	  nTools.gigyaUxReady = function () {
	    return Voonto.getInstance().when('vocuser:ready').then(function (gigyaUX) {
	      return gigyaUX;
	    });
	  };
	  /**
	   * Actualiza la Publi segun el Id y la Poscición que se le indique
	   * @param eid Id de la posisción de publi a refrescar (robapaginas_dos-id, boton_native-id, ... etc)
	   * @param pos Posición de la publi que se va a refrescar (robapaginas_dos, boton_native  ... etc)
	   */
	  nTools.refreshPubli = function (eid, pos) {
	    var data = {};
	    if (typeof eid !== "undefined") {
	      data = { "id": eid, "position": pos, "refresh": true };
	      app.trigger('vam:refresh', data);
	      //Logger.debug('[nTools] -- Refresh Publi', data);
	    }
	    return data;
	  };
	
	  nTools.kebabCase = function (string) {
	    var result = string;
	    // Convert camelCase capitals to kebab-case.
	    result = result.replace(/([a-z][A-Z])/g, function (match) {
	      return match.substr(0, 1) + '-' + match.substr(1, 1);
	    });
	    // Convert non-camelCase capitals to lowercase.
	    result = result.toLowerCase();
	    // Convert non-alphanumeric characters to hyphens
	    result = result.replace(/[^-a-z0-9]+/g, '-');
	    // Remove hyphens from both ends
	    result = result.replace(/^-+/, '').replace(/-$/, '');
	    return result;
	  };
	
	  /**
	   * Verifica si el json que se recibe es correcto o no.
	   * @param string
	   */
	  nTools.checkIsValidJson = function (string) {
	    try {
	      JSON.parse(string);
	    } catch (e) {
	      return false;
	    }
	    return true;
	  };
	
	  nTools.normalizer = function (str) {
	    var caps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return _normalizer2.default.normalize(str, caps);
	  };
	
	  nTools.isPremium = function () {
	    return typeof window.voc_ate !== 'undefined' && window.voc_ate === 'si';
	  };
	
	  /* Ajuste de Politicas de Cookies salga la configuración de preferencias */
	  /* lo agregamos de manera general para todos, portadas, noticias todos! */
	  Voonto.$('.politica-cookie').on('click', function (e) {
	    //Logger.debug('[conf-cookie] ejecutando..');
	    e.preventDefault();
	    Voonto.cmp.show();
	
	    return false;
	  });
	
	  return {
	    app: app,
	    nTools: nTools
	  };
	}(window);
	
	window.nibara = NibaraInstance;

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	var charMap = exports.charMap = __webpack_require__(18);
	
	var normalize = exports.normalize = function(origString, keepCase){
		var newString = origString;
		
		for(var char in charMap){
			var rex = new RegExp('[' + charMap[char].toString() + ']', 'g');
			try{
				origString = origString.replace(rex, char);
			} catch(e) {
				console.log('error', origString);
			}
		}
		return keepCase? origString : origString.toLowerCase();
	};
	
	var normalizeFilter = exports.normalizeFilter = function(origFilter, model, wholeString, keepCase){
		var schema = model.schema? model.schema.tree.normalized : model;
		var newFilter = {};
		var finalFilter = {};
	
		var getFilterResult = function(string){
			return wholeString? 
				normalize(string, keepCase) : 
					new RegExp(normalize(string, keepCase), 'i');
		};
	
		var recurse = function(filter, path, schema){
			for(var key in filter){
				var filterResult;
				if(key in schema){
					var normalized = getPathString(key, path);
					if(typeof filter[key] === 'string'){
						filterResult = getFilterResult(filter[key]);
						newFilter[getPathString(key, path) + key] = filterResult;
					} else{
						path.push(key);
						recurse(filter[key], path, schema[key]);
					}
	
				} else {
					newFilter[key] = typeof filter[key] === 'string'? filterResult : filter[key];
				}
			}
			return newFilter;
		};
		finalFilter = recurse(origFilter, [], schema);
		return finalFilter;	
	};
	
	var normalizeSort = exports.normalizeSort = function(origSort, model){
		var schema = model.schema? model.schema.tree.normalized : model;
		var newSort = {};
		var finalSort = {};
	
		var recurse = function(sort, path, schema){
			for(var key in sort){
				if(key in schema && !(key in newSort)){
					if(typeof sort[key] !== 'object'){
						newSort[getPathString(key, path) + key] = sort[key];
					} else{
						path.push(key);
						recurse(sort[key], path, schema[key]);
					}
	
				} else {
					newSort[key] = sort[key];
				}
			}
			return newSort;
		};
		finalSort = recurse(origSort, [], schema);
		return finalSort;	
	};
	
	var normalizeSearchFields = exports.normalizeSearchFields = function(doc, model, keepCase){
		var schema = model.schema? model.schema.tree.normalized : model;
		var recurse = function(doc, normalized, schema){
			var newDoc = {};
			for(var key in doc){
				if(key in schema){
					if(typeof doc[key] === 'object'){
						var normal = newDoc[key] = {};
						newDoc[key] = recurse(doc[key], normal , schema[key]);
					} else {
						newDoc[key] = typeof doc[key] === 'string'? normalize(doc[key], keepCase) : doc[key];
					}
				}
			}
			return newDoc;
		};
	
		var finalDoc = {normalized: {}};
		for(var key in doc){
			finalDoc[key] = doc[key];
		}
		finalDoc.normalized = recurse(doc, finalDoc.normalized, schema);
		return finalDoc;
	};
	
	
	var getPathString = function(key, path){
		var pathString = 'normalized';
		if(path.length > 0){
			pathString += '.' +  path.join('.');
		}
		pathString += '.';
		return pathString;
	};

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

	module.exports = {
		'a': ['á','Á','à','À','ã','Ã','â','Â','ä','Ä','å','Å','ā','Ā'],
		'e': ['é','É','è','È','ê','Ê','ë','Ë','ē','Ē','ė','Ė','ę','Ę'],
		'i': ['î','Î','í','Í','ì','Ì','ï','Ï','ī','Ī','į','Į'],
		'o': ['ô','Ô','ò','Ò','ø','Ø','ō','Ō','ó','Ó','õ','Õ','ö','Ö'],
		'u': ['û','Û','ú','Ú','ù','Ù','ü','Ü','ū','Ū'],
		'c': ['ç','Ç','č','Č'],
		's': ['ś','Ś','š','Š'],
	};


/***/ }),

/***/ 21:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	/**
	 * Modulo para recuperar que feature de nibara están activadas.
	 * @author Felipe Galindo <fgalindo@vocento.com>
	 */
	
	var DEFAULT_COOKIE_LAW = 0;
	var DEFAULT_BREAKING_NEWS = 1;
	var DEFAULT_TE_INTERESA = 1;
	var DEFAULT_PUSH_NOTIFICATION = 1;
	var DEFAULT_SHARE_LAYER = 1;
	var DEFAULT_HOME_BACKTRACE = 1;
	var DEFAULT_STICKY_ADS = 1;
	var DEFAULT_JQ_STICKY_ADS = 0;
	
	var app = Voonto.getInstance();
	var configFeature = app.lookup('vocento.config.nibara.feature');
	var urlParams = nibara.nTools.getUrlParams();
	
	function getFeatureParam(name) {
		return urlParams.queryParams[name] || urlParams.queryHash[name] || configFeature[name];
	}
	
	function getFeatures() {
	
		var pStickyAds = getFeatureParam('stickyAds');
		var pJqStickyAds = getFeatureParam('jqStickyAds');
		var pBreakingNews = getFeatureParam('breakingNews');
		var pCookieLaw = getFeatureParam('cookieLaw');
		var pPushNotification = getFeatureParam('pushNotification');
		var pTeInteresa = getFeatureParam('teInteresa');
		var pShareLayer = getFeatureParam('shareLayer');
		var pHomeBacktrace = typeof history.state === 'undefined' ? 0 : getFeatureParam('homeBacktrace');
	
		return {
			"stickyAds": pStickyAds === undefined ? DEFAULT_STICKY_ADS : pStickyAds | 0,
			"jqStickyAds": pJqStickyAds === undefined ? DEFAULT_JQ_STICKY_ADS : pJqStickyAds | 0,
			"breakingNews": pBreakingNews === undefined ? DEFAULT_BREAKING_NEWS : pBreakingNews | 0,
			"teInteresa": pTeInteresa === undefined ? DEFAULT_TE_INTERESA : pTeInteresa | 0,
			"cookieLaw": pCookieLaw === undefined ? DEFAULT_COOKIE_LAW : pCookieLaw | 0,
			"pushNotification": pPushNotification === undefined ? DEFAULT_PUSH_NOTIFICATION : pPushNotification | 0,
			"shareLayer": pShareLayer === undefined ? DEFAULT_SHARE_LAYER : pShareLayer | 0,
			"homeBacktrace": pHomeBacktrace === undefined ? DEFAULT_HOME_BACKTRACE : pHomeBacktrace | 0
		};
	}
	
	exports.default = getFeatures;

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	module.exports = {"name":"abc-nibara-static","version":"3.0.30","description":"Javascript para abc","main":"src/index.js","scripts":{"test":"echo \"Warning: No tests specified\" && exit 0","start":"./node_modules/.bin/webpack --watch","build":"./node_modules/.bin/webpack","build:watch":"./node_modules/.bin/webpack --watch"},"author":"mbiencinto@vocento.com|fgalindo@vocento.com|jvortiz@ces.vocento.com","license":"SEE LICENSE IN LICENSE.md","devDependencies":{"babel-core":"^6.17.0","babel-loader":"^6.2.5","babel-polyfill":"^6.16.0","babel-preset-es2015":"^6.16.0","chai":"^3.5.0","chalk":"^1.1.3","copy-webpack-plugin":"^4.6.0","html-webpack-plugin":"^2.24.1","json-loader":"^0.5.4","mocha":"^3.1.0","mocha-loader":"^1.0.0","mocha-phantomjs":"^4.1.0","webpack":"^1.13.3","webpack-shell-plugin":"^0.4.3"},"dependencies":{"normalizer":"^1.2.7"}}

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ModuleLoader = function () {
	  function ModuleLoader(app) {
	    _classCallCheck(this, ModuleLoader);
	
	    this.app = app;
	    this.path = app.lookup('vocento.config.nibara').path;
	    if (this.path === undefined) {
	      throw 'nibara path config is empty';
	    }
	    this.libPath = app.lookup('vocento.config.nibara').libPath;
	    if (this.libPath === undefined) {
	      throw 'nibara libPath config is empty';
	    }
	    this.modules = {};
	  }
	
	  _createClass(ModuleLoader, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      var $elm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	      var Logger = nibara.logger;
	      Logger.debug('ModuleLoader: Initialize');
	
	      /**
	       * InView elements
	       */
	      var nibaraInviewElms = [];
	      if ($elm !== null) {
	        nibaraInviewElms = $elm.find('.nibara-element-inview');
	      } else {
	        nibaraInviewElms = Voonto.$('.nibara-element-inview');
	      }
	
	      if (nibaraInviewElms) {
	        this.app.load(this.libPath + 'jquery-inview-tea3/jquery.inview.min.js').then(function () {
	          nibaraInviewElms.each(function (key, elm) {
	            var $elm = Voonto.$(elm);
	            var offset = $elm.data('offset') || 0;
	            var theObj = _this;
	
	            /** switch mode LIVE (ON) */
	            if ($elm.data('nibara-inview-mode') === 'live') {
	              $elm.on('inview', function (event, isInView, visiblePartX, visiblePartY) {
	
	                /** wakeup only once */
	                if ($elm.data('awakened') !== true) {
	                  _this.callModuleMethod($elm, 'wakeUp');
	                  $elm.data('awakened', true);
	                }
	                /** top view event */
	                if (isInView && visiblePartY === 'top') {
	                  Logger.debug('[inview live] Visible TOP: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	
	                  if (window.nibara.isBack && $elm.data('section') !== window.nibara.lastSectionView) {
	                    var promise = new Promise(function (resolve, reject) {
	
	                      var moduleName = $elm.data('nibara-module');
	                      if (moduleName) {
	                        theObj.callModuleMethod($elm, 'visibleTop');
	                        resolve();
	                      } else {
	                        reject();
	                      }
	                    });
	                    promise.then(function (result) {
	                      Logger.debug('[inview live] Visible TOP: Promesa ok para la sección ' + $elm.data('section'));
	                    }).catch(function (error) {
	                      Logger.debug('[inview live] Visible TOP: Promesa falló para la sección ' + $elm.data('section') + '.Error: ' + error.message);
	                    });
	                  } else {
	                    _this.callModuleMethod($elm, 'visibleTop');
	                  }
	                }
	                /** bottom view event */
	                if (isInView && visiblePartY === 'bottom') {
	                  Logger.debug('[inview live] Visible BOTTOM: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  if (window.nibara.isBack && $elm.data('section') !== window.nibara.lastSectionView) {
	                    var _promise = new Promise(function (resolve, reject) {
	                      var moduleName = $elm.data('nibara-module');
	                      if (moduleName) {
	                        theObj.callModuleMethod($elm, 'visibleBottom');
	                        resolve();
	                      } else {
	                        reject();
	                      }
	                    });
	                    _promise.then(function (result) {
	                      Logger.debug('[inview live] Visible BOTTOM: Promesa ok para la sección ' + $elm.data('section'));
	                    }).catch(function (error) {
	                      Logger.debug('[inview live] Visible BOTTOM: Promesa falló para la sección ' + $elm.data('section') + '.Error: ' + error.message);
	                    });
	                  } else {
	                    _this.callModuleMethod($elm, 'visibleBottom');
	                  }
	                }
	                /** entire view event */
	                if (isInView && visiblePartY === 'both') {
	                  //Logger.debug('[inview live] Visible ENTIRE: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'visibleEntire');
	                }
	                /** out view event */
	                if (!isInView) {
	                  //Logger.debug('[inview live] NOT Visible: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'notVisible');
	                }
	              });
	
	              /** switch mode ONE */
	            } else {
	              $elm.one('inview', function (event, isInView) {
	                if (isInView) {
	                  //Logger.debug('[inview one] Visible: ' + Voonto.$(elm).data('nibara-module') + ' with offset:' + offset);
	                  _this.callModuleMethod($elm, 'wakeUp');
	                }
	              });
	            }
	          });
	        });
	      }
	
	      /**
	       * NO InView elements
	       */
	      var nibaraElms = [];
	      if ($elm !== null) {
	        nibaraElms = $elm.find('.nibara-element');
	      } else {
	        nibaraElms = Voonto.$('.nibara-element');
	      }
	
	      if (nibaraElms) {
	        nibaraElms.each(function (key, elm) {
	          var $elm = Voonto.$(elm);
	          _this.callModuleMethod($elm, 'wakeUp');
	        });
	      }
	    }
	
	    /**
	     * Call to module and exec method
	     * @param $elm
	     * @param method
	     */
	
	  }, {
	    key: 'callModuleMethod',
	    value: function callModuleMethod($elm, method) {
	      var _this2 = this;
	
	      var Logger = nibara.logger;
	      var moduleName = $elm.data('nibara-module');
	      if (moduleName) {
	        if (this.modules[moduleName]) {
	          var module = this.modules[moduleName];
	          if (typeof module[method] === 'function') {
	            module[method]($elm);
	          } else {
	            Logger.warn('Method "' + method + '" not found in module "' + moduleName + '"');
	          }
	        } else {
	          var elementFilePath = this.path + '/' + moduleName + '-module.js';
	          elementFilePath = window.nibara.nTools.getStaticNode(elementFilePath);
	          this.app.require([elementFilePath], function (module) {
	            _this2.modules[moduleName] = module;
	            if (typeof module[method] === 'function') {
	              module[method]($elm);
	            } else {
	              Logger.warn('Method "' + method + '" not found in module "' + elementFilePath + '"');
	            }
	          });
	        }
	      }
	    }
	  }]);
	
	  return ModuleLoader;
	}();
	
	exports.default = ModuleLoader;

/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScriptLoader = function () {
	  function ScriptLoader(app) {
	    _classCallCheck(this, ScriptLoader);
	
	    this.app = app;
	    this.path = app.lookup('vocento.config.nibara').path;
	    if (this.path === undefined) {
	      throw 'nibara path config is empty';
	    }
	  }
	
	  _createClass(ScriptLoader, [{
	    key: 'initialize',
	    value: function initialize() {
	      var _this = this;
	
	      var Logger = nibara.logger;
	      Logger.debug('ScriptLoader: Initialize');
	
	      var categoriesStr = Voonto.$('body').data('nibara-loader');
	      if (categoriesStr) {
	        categoriesStr.split(" ").forEach(function (category) {
	          if (category.trim().length > 0) {
	            //Evita los espacios blancos grandes o continuos
	            var scriptName = _this.path + ('/' + category + '-script.js');
	            scriptName = window.nibara.nTools.getStaticNode(scriptName);
	            Logger.debug('ScriptLoader: loading script: ' + scriptName);
	            //Logger.debug('ScriptLoader: loading script: ' + category);
	            _this.app.load(scriptName).catch(function (e) {
	              Logger.error(scriptName + ' not found: ' + e.message);
	            });
	          }
	        });
	      }
	      Logger.debug('ScriptLoader End');
	    }
	  }]);
	
	  return ScriptLoader;
	}();
	
	exports.default = ScriptLoader;

/***/ })

/******/ })
});
;


// WEBPACK FOOTER //
// nibara.js